import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

export const WelcomeNav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (id) => {
    setMobileOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-md shadow-sm border-b border-gray-100'
          : 'bg-transparent'
      }`}
      data-testid="welcome-nav"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          <Link to="/" className="flex items-center group flex-shrink-0" data-testid="welcome-nav-logo">
            <img
              src={scrolled ? '/brand/kgob-logo-light.svg' : '/brand/kgob-logo-dark.svg'}
              alt="Kohari Gonzalez Oneyear & Brown CPAs & Advisors"
              className="h-10 w-auto object-contain transition-transform duration-300 group-hover:scale-[1.03]"
            />
          </Link>

          <div className="hidden md:flex items-center space-x-8" style={{ fontFamily: "'Kanit', system-ui, sans-serif" }}>
            <Link
              to="/our-story"
              className={`text-sm font-medium transition-colors ${
                scrolled ? 'text-[#0B2240]/80 hover:text-[#0B2240]' : 'text-white/90 hover:text-white'
              }`}
              data-testid="welcome-nav-about"
            >
              About
            </Link>
            <Link
              to="/services"
              className={`text-sm font-medium transition-colors ${
                scrolled ? 'text-[#0B2240]/80 hover:text-[#0B2240]' : 'text-white/90 hover:text-white'
              }`}
              data-testid="welcome-nav-services"
            >
              Services
            </Link>
            <button
              onClick={() => scrollTo('contact')}
              className={`text-sm font-medium transition-colors ${
                scrolled ? 'text-[#0B2240]/80 hover:text-[#0B2240]' : 'text-white/90 hover:text-white'
              }`}
              data-testid="welcome-nav-contact"
            >
              Contact
            </button>
          </div>

          <button
            className="md:hidden p-2"
            onClick={() => setMobileOpen(!mobileOpen)}
            data-testid="welcome-nav-mobile-toggle"
          >
            {mobileOpen ? (
              <X className={`h-6 w-6 ${scrolled ? 'text-[#0B2240]' : 'text-white'}`} />
            ) : (
              <Menu className={`h-6 w-6 ${scrolled ? 'text-[#0B2240]' : 'text-white'}`} />
            )}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 shadow-lg">
          <div className="px-4 py-4 space-y-3">
            <Link data-testid="welcome-nav-link-2"
              to="/our-story"
              className="block text-[#0B2240] text-sm font-medium py-2"
              onClick={() => setMobileOpen(false)}
            >
              About
            </Link>
            <Link data-testid="welcome-nav-link-1"
              to="/services"
              className="block text-[#0B2240] text-sm font-medium py-2"
              onClick={() => setMobileOpen(false)}
            >
              Services
            </Link>
            <button data-testid="welcome-nav-button-1"
              onClick={() => scrollTo('contact')}
              className="block text-[#0B2240] text-sm font-medium py-2 w-full text-left"
            >
              Contact
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};
